import * as React from 'react'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import SpeedDialAction from '@mui/material/SpeedDialAction'

import AbcIcon from '@mui/icons-material/Abc'
import TranslateIcon from '@mui/icons-material/Translate'
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import ChatIcon from '@mui/icons-material/Chat'
import ViewKanbanIcon from '@mui/icons-material/ViewKanban'
import StyleIcon from '@mui/icons-material/Style'
import EventNoteIcon from '@mui/icons-material/EventNote'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import PermMediaIcon from '@mui/icons-material/PermMedia'
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import SpellcheckIcon from '@mui/icons-material/Spellcheck'
import ScienceIcon from '@mui/icons-material/Science'
import SchoolIcon from '@mui/icons-material/School'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import PersonIcon from '@mui/icons-material/Person'
import ReplayIcon from '@mui/icons-material/Replay'
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople'
import AssignmentIcon from '@mui/icons-material/Assignment'

export default function HallucinationButton({
  toggleViewHallucination,
  toggleViewTranslation,
  toggleViewSpeech,
  toggleViewManyInspirations,
  toggleManyTranslationsFullView,
  toggleViewLanguagePartner,
  toggleViewKanban,
  toggleViewTaskBoard,
  toggleViewSpeechPractice,
  toggleFlashcardView,
  toggleMeetingView,
  toggleParagraphView,
  toggleMediaView,
  toggleJournalView,
  openAiLesson,
  openImportLesson,
  openProfile,
  openReviewDue,
  openIntroduce,
  openHomework,
  toggleVerbLab,
  toggleSpecialMode,
  toggleLanguageTree
}) {
  // The newest learning features — split out of the (previously 19-item) views
  // menu into their own button so neither dial is overloaded.
  const learnActions = [
    { icon: <AccountTreeIcon />, name: 'Skill Tree', onClick: () => toggleLanguageTree && toggleLanguageTree() },
    { icon: <ReplayIcon />, name: 'Review due', onClick: () => openReviewDue && openReviewDue() },
    { icon: <EmojiPeopleIcon />, name: 'Introduce Yourself', onClick: () => openIntroduce && openIntroduce() },
    { icon: <PersonIcon />, name: 'Profile', onClick: () => openProfile && openProfile() },
    { icon: <AssignmentIcon />, name: 'Homework', onClick: () => openHomework && openHomework() },
    { icon: <SchoolIcon />, name: 'Import Lesson', onClick: () => openImportLesson && openImportLesson() },
    { icon: <AutoAwesomeIcon />, name: 'AI Lesson', onClick: () => openAiLesson && openAiLesson() },
    { icon: <SpellcheckIcon />, name: 'Verb Lab', onClick: () => toggleVerbLab && toggleVerbLab() },
    { icon: <ScienceIcon />, name: 'Special Mode', onClick: () => toggleSpecialMode && toggleSpecialMode() }
  ]

  // The original content views.
  const viewActions = [
    { icon: <AbcIcon />, name: 'Inspirations View', onClick: () => toggleViewHallucination() },
    { icon: <TranslateIcon />, name: 'Translation View', onClick: () => toggleViewTranslation() },
    { icon: <RecordVoiceOverIcon />, name: 'Speech Translation', onClick: () => toggleViewSpeech() },
    { icon: <RecordVoiceOverIcon />, name: 'Speech Practice', onClick: () => toggleViewSpeechPractice() },
    { icon: <ChatIcon />, name: 'Language Partner', onClick: () => toggleViewLanguagePartner() },
    { icon: <ChatIcon />, name: 'Many Translations', onClick: () => toggleManyTranslationsFullView() },
    { icon: <StyleIcon />, name: 'Flashcards', onClick: () => toggleFlashcardView() },
    { icon: <EventNoteIcon />, name: 'Meetings', onClick: () => toggleMeetingView() },
    { icon: <MenuBookIcon />, name: 'Paragraphs', onClick: () => toggleParagraphView() },
    { icon: <PermMediaIcon />, name: 'Media', onClick: () => toggleMediaView() },
    { icon: <SelfImprovementIcon />, name: 'Journal', onClick: () => toggleJournalView() }
    // { icon: <ViewKanbanIcon />, name: 'Kanban', onClick: () => toggleViewKanban() },
    // { icon: <ViewKanbanIcon />, name: 'Task Board', onClick: () => toggleViewTaskBoard() }
    // { icon: <AbcIcon />, name: 'Many Inspirations', onClick: () => toggleViewManyInspirations() }
  ]

  return (
    <>
      <SpeedDial
        direction="up"
        ariaLabel="SpeedDialViews"
        icon={<PlayArrowIcon />}
        FabProps={{ sx: fabSx('#2563eb', '#1d4ed8') }}>
        {viewActions.map((action) => (
          <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} onClick={action.onClick} />
        ))}
      </SpeedDial>
      <SpeedDial
        direction="up"
        ariaLabel="SpeedDialLearn"
        icon={<SchoolIcon />}
        FabProps={{ sx: fabSx('#059669', '#047857') }}>
        {learnActions.map((action) => (
          <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} onClick={action.onClick} />
        ))}
      </SpeedDial>
    </>
  )
}

// Shared Fab colouring for the floating menu buttons — solid colour, a slightly
// darker shade on hover, white icon.
const fabSx = (bg, hover) => ({ bgcolor: bg, color: '#fff', '&:hover': { bgcolor: hover } })
